/* eslint-disable fp/no-mutation */
/* eslint-disable fp/no-let */
import PropTypes from 'prop-types';
import React from 'react';

const PADDING = 16;

class AutoPositioner extends React.Component {
  constructor(props) {
    super(props);

    // Ref callback set up for React < 16.3
    this.setAutoPositionerRef = (node) => { this.autoPositioner = node; };

    this.state = {
      adjustedYPosition: 0,
      originalHeight: document.documentElement.scrollHeight,
      originalYScrollDistance: window.scrollY,
    };
  }

  componentDidMount() {
    const { originalHeight, originalYScrollDistance } = this.state;

    if (this.autoPositioner.lastChild.getBoundingClientRect().bottom + originalYScrollDistance > originalHeight) {
      const absoluteBottomPosOfNode = this.autoPositioner.lastChild.getBoundingClientRect().bottom + window.scrollY;
      const absoluteTopOfNode = this.autoPositioner.firstChild.getBoundingClientRect().top + window.scrollY;
      let adjustedYOffsetFromBottom = absoluteBottomPosOfNode - originalHeight;

      // If the new adjusted top position of children is past the top of the screen, move it down
      if ((absoluteTopOfNode - adjustedYOffsetFromBottom) < 0) {
        adjustedYOffsetFromBottom += (absoluteTopOfNode - adjustedYOffsetFromBottom - PADDING);
      } else {
        adjustedYOffsetFromBottom += PADDING;
      }

      this.setState({
        adjustedYPosition: adjustedYOffsetFromBottom,
      });
    }
  }

  render = () => (
    <div ref={this.setAutoPositionerRef} style={{ bottom: `${this.state.adjustedYPosition}px`, padding: `${PADDING} 0`, position: 'relative' }}>
      {this.props.children}
    </div>
  );
}

AutoPositioner.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AutoPositioner;
